const isAbsolutePath = value => {
  const splittedRegex = ['((([A-Za-z]{3,9}:(?:\\/\\/)?)(?:[\\-;:&=\\+\\$,\\w]+@)?[A-Za-z0-9\\.\\-]+|(?:www\\.|[\\-;:&=\\+\\$,\\w]+@)[A-Za-z0-9\\.\\-]+)', '((?:\\/[\\+~%\\/\\.\\w\\-_]*)?\\??(?:[\\-\\+=&;%@\\.\\w_]*)#?(?:[\\.\\!\\/\\\\\\w]*))?)'].join('');
  const regex = new RegExp(splittedRegex);
  return regex.test(value);
};
export default isAbsolutePath;
//# sourceMappingURL=is-absolute-path.js.map